module.exports = __webpack_public_path__ + "static/Aulia Chairunisa-fb418a6cd2ddc34b9d72b64a3381dc06.jpg";